export enum PanelType {
    INFO = 'Info',
    PROMO = 'Promo',
    FILTER = 'Filter',
    SELECTION = 'Selection',
}